import * as Yup from 'yup';

export const validationSchema = Yup.object().shape({
  soft_collection: Yup.boolean(),
  invoice_number_pattern: Yup.string().trim().required('msg_error_required_field'),
});
